module.exports = __webpack_public_path__ + "img/1570932788.1537260e.jpg";